import { ApiResponse } from './types';
import { apiClient } from './core/apiClient';
import { IRole, IRoleMutationRequest } from '../types/interfaces/IRole';

function withInstitutionId(path: string, institutionId?: string): string {
  if (!institutionId) return path;
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}institutionId=${encodeURIComponent(institutionId)}`;
}

export async function getRoles(institutionId?: string): Promise<ApiResponse<IRole[]>> {
  return apiClient.get<IRole[]>(withInstitutionId('/roles', institutionId));
}

export async function getRoleById(
  id: string,
  institutionId?: string
): Promise<ApiResponse<IRole>> {
  return apiClient.get<IRole>(withInstitutionId(`/roles/${id}`, institutionId));
}

export async function createRole(
  data: IRoleMutationRequest,
  institutionId?: string
): Promise<ApiResponse<IRole>> {
  return apiClient.post<IRole>(withInstitutionId('/roles', institutionId), data);
}

export async function updateRole(
  id: string,
  data: IRoleMutationRequest,
  institutionId?: string
): Promise<ApiResponse<IRole>> {
  return apiClient.put<IRole>(withInstitutionId(`/roles/${id}`, institutionId), data);
}

export async function deleteRole(
  id: string,
  institutionId?: string
): Promise<ApiResponse<boolean>> {
  return apiClient.delete<boolean>(withInstitutionId(`/roles/${id}`, institutionId));
}

export async function toggleRoleStatus(
  id: string,
  institutionId?: string
): Promise<ApiResponse<IRole>> {
  return apiClient.patch<IRole>(
    withInstitutionId(`/roles/${id}/toggle-status`, institutionId)
  );
}
